import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
  ReflectiveInjector
} from '@angular/core';

export class ActiveModal {
  dismiss(): void {
  }

  close(result?: any): void {
  }
}

export class ModalRef {
  private _resolve: (result?: any) => void;
  private _reject: (reason?: any) => void;


  get componentInstance(): any {
    if (this.componentRef) {
      return this.componentRef.instance;
    }
  }

  result: Promise<any>;

  constructor(private componentRef: ComponentRef<any>) {
    this.result = new Promise((resolve, reject) => {
      this._resolve = resolve;
      this._reject = reject;
    });
    this.result.then(null, () => {
    });
  }

  close(result?: any): void {
    this._resolve(result);

    /*if (this._windowCmptRef) {

      this._removeModalElements();
    }*/
  }
}


@Injectable()
export class ModalService {

  constructor(private appRef: ApplicationRef,
              private injector: Injector,
              private componentFactoryResolver: ComponentFactoryResolver) {
  }

  open(component: any): ModalRef {
    const containerEl = document.querySelector('body');
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);

    const activeModal = new ActiveModal();

    let ref: ModalRef;

    const modalContentInjector =
      ReflectiveInjector.resolveAndCreate([{ provide: ActiveModal, useValue: activeModal }], this.injector);

    const componentRef = this.componentFactoryResolver
      .resolveComponentFactory(component)
      .create(modalContentInjector);

    ref = new ModalRef(componentRef);

    activeModal.close = (result: any) => {
      ref.close(result);
      setTimeout(() => {
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
      }, 50);
    };

    activeModal.dismiss = () => {
      setTimeout(() => {
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
      }, 0);
    };

    this.appRef.attachView(componentRef.hostView);

    const domElem = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

    // 4. Append DOM element to the body
    document.body.appendChild(domElem);

    return ref;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/modal.service.ts